import React, { Fragment } from 'react';
import { dateFormat } from '../../Services/formatting';

const CartGridDeliveryDate = ({usePreferredDeliveryDate, preferredDeliveryDate, preliminaryDeliveryDate}) => {
  return (
    <Fragment>
      {!usePreferredDeliveryDate &&
        new Date(preferredDeliveryDate).getFullYear() !== 1 && (
          <div style={{ textDecoration: 'line-through' }}>
            {dateFormat.format(
              Date.parse(preferredDeliveryDate)
            )}
          </div>
        )}
      {new Date(preferredDeliveryDate) >
        new Date(preliminaryDeliveryDate) && (
        <div style={{ textDecoration: 'line-through' }}>
          {dateFormat.format(Date.parse(preferredDeliveryDate))}
        </div>
      )}
      {dateFormat.format(Date.parse(preliminaryDeliveryDate))}
    </Fragment>
  );
};

export default CartGridDeliveryDate;
